import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ServicesSection } from "@/components/ServicesSection";
import { CTASection } from "@/components/CTASection";
import { SEO } from "@/components/seo/SEO";

const Diensten = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <SEO
          title="Complete Energieoplossingen | Zonnepanelen & Warmtepompen | SOL-VI"
          description="🏠 Complete duurzame energieoplossingen: zonnepanelen, warmtepompen, thuisbatterijen, laadpalen & elektra ⚡ Maatwerk advies ✅ Gratis offerte in Gelderland"
          keywords="duurzame energieoplossingen, complete energieoplossingen, zonnepanelen warmtepomp, energieneutraal wonen, maatwerk energieoplossingen, groene energie Gelderland"
          canonical="https://sol-vi.nl/diensten"
          type="website"
        />
        <div className="pt-20 pb-12 bg-gradient-subtle">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Onze Diensten</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              SOL-VI biedt complete duurzame energieoplossingen voor uw woning. 
              Van zonnepanelen tot warmtepompen - wij zorgen voor een energieneutrale toekomst.
            </p>
          </div>
        </div>
        <ServicesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Diensten;